import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';
import { DashboardKey } from 'flow/types/EntityKeys';

import { selectDashboard } from 'flow/selectors/DashboardsSelectors';
import Loading from 'flow/components/ui-components/Loading';
import DashboardCreate from 'flow/components/dashboard/DashboardCreate';
import { wallboardTypes } from 'flow/utils/wallboard-utils';

const DashboardCreateWrapper = () => {
    const { wallboardTypePath, wallboardKey: dashboardKey } = useParams<{
        wallboardTypePath?: 'groups' | 'team-custom';
        wallboardKey?: DashboardKey;
    }>();

    const dashboard = useAppSelector((state) =>
        dashboardKey ? selectDashboard(state, dashboardKey) : undefined,
    );

    if (dashboardKey) {
        if (!dashboard) return <Loading />;
        const boardType = dashboard.get('type');
        return (
            <DashboardCreate
                boardType={boardType}
                dashboardKey={dashboardKey}
                dashboardFromStore={dashboard}
            />
        );
    }

    if (wallboardTypePath) {
        const boardType = getTypeFromUrlPathKey(wallboardTypePath);
        return <DashboardCreate boardType={boardType} />;
    }

    return null;
};

export default DashboardCreateWrapper;

const getTypeFromUrlPathKey = (urlPathKey: 'team-custom' | 'groups') => {
    if (urlPathKey === 'team-custom') {
        return wallboardTypes.TEAM_CUSTOM;
    }

    if (urlPathKey === 'groups') {
        return wallboardTypes.HUNT_GROUPS_MULTIPLE;
    }
};
